import urls from "../urls/urls";
import _ from "lodash";
import RequestClient from "../api/requestClient";
import { getNotificationService } from "../notifications";
import { getInstance } from "../auth";
import store from "../store";

class ProfileService {
  async getProfile() {
    return await RequestClient.get(urls.auth0.api.user());
  }

  async saveProfile(profile) {
    const patch = this.createPatch(profile);
    if (!Object.keys(patch).length) {
      getNotificationService().warning("profile-service.nothing-to-save");
      return;
    }

    var response = await RequestClient.patch(urls.auth0.api.user(), patch);

    getNotificationService().success("profile-service.profile-updated");

    return _.cloneDeep(response);
  }

  createPatch(profile) {
    return this.difference(profile, store.state.currentProfile);
  }

  difference(object, base) {
    function changes(object, base) {
      return _.transform(object, function (result, value, key) {
        if (!_.isEqual(value, base[key])) {
          result[key] =
            _.isObject(value) && _.isObject(base[key]) ? changes(value, base[key]) : value;
        }
      });
    }
    return changes(object, base);
  }

  async updatePassword(request) {
    var profile = store.state.currentProfile;
    request.email = profile.email;
    await RequestClient.patch(urls.auth0.api.userPassword(), request);
  }

  async resetPassword() {
    const profile = store.state.currentProfile;
    await RequestClient.post(urls.auth0.api.userPasswordReset(), { email: profile.email });

    const auth = getInstance();
    auth.logout();
  }

  async logOut() {
    const auth = getInstance();
    auth.logout();
  }
}

export default new ProfileService();
